import React from 'react';

import SecurityComponent from '../components/app/Security/Security';

const Security = (props) => {
  return (
    <SecurityComponent {...props} />
  );
};

export default Security;
